<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    to="/chemical/0"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="chemical-count" >
                     {{ total + ' Chemicals Found.' }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-list two-line tile flat class="py-0">
                <template v-for="(chemical, index) in chemicals">
                    <v-list-item
                    :key="`chemical-${index}`"
                    :value="chemical.id"     
                    :to="{ path: '/chemical/'+ chemical.id }"            
                    >
                        <template>
                            <v-list-item-content>
                                <v-list-item-title v-html="chemical.title"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-list-item-icon class="ma-0 w-100">
                                    <v-btn small color="primary" :to="{ path: '/chemical/'+ chemical.id }" tile elevation="0">Edit</v-btn>
                                </v-list-item-icon>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                    <v-divider
                    :key="`dv-${index}`"
                    ></v-divider>
                </template>
                <v-list-item v-if="pagination.total > 1">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
        <FilterChemicals :show="drawer" :filter="filter" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @submit-search="submitSearch"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterChemicals from '../components/FilterChemicals.vue'

export default {
    data() {
        return {
            drawer: false,
            loading: true,
            chemicals: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            filter: {
                keyword: "",
            },
            total: 0,
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.getChemicals()
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else {
                return this.pageTitle
            }
        },
    },
    components: {
        FilterChemicals
    },
    methods: {
        getChemicals() {
            this.loading = true
            this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.chemicals = response.data.chemicals.data
                this.pagination.current = response.data.chemicals.current_page
                this.pagination.total = response.data.chemicals.last_page
                this.total = response.data.chemicals.total
                this.stats = response.data.stats
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getChemicals()
            this.$vuetify.goTo(0)
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        submitSearch() {
            this.getChemicals()
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff
.fullscreen
    background: #fff
    height: 100%
.w-100
    width: 100%
    .v-btn 
        width: 100%
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.v-chip 
    border-radius: 0!important
.chemical-count
    font-size: 14px
</style>